import { onMounted, onBeforeUnmount } from 'vue';

export interface UseKeyboardCloseOptions {
  onEscape: (event: KeyboardEvent) => void;
  container?: () => HTMLElement | null;
  topmostSelector?: string;
  requireFocusInside?: boolean;
  onKeyUp?: (event: KeyboardEvent) => void;
}
export function useKeyboardClose(options: UseKeyboardCloseOptions) {
  const {
    onEscape,
    container,
    topmostSelector = '.modal.show',
    requireFocusInside = false,
    onKeyUp,
  } = options;

  const handleKeyUp = (event: KeyboardEvent) => {
    const isEsc =
      event.key === 'Escape' || event.key === 'Esc' || event.which === 27;
    if (!isEsc) {
      onKeyUp?.(event);
      return;
    }

    const modals = document.querySelectorAll<HTMLElement>(topmostSelector);
    const top = modals[modals.length - 1] || null;

    if (container) {
      const el = container();
      if (!el || top !== el) {
        onKeyUp?.(event);
        return;
      }
      if (requireFocusInside) {
        const active = document.activeElement as Node | null;
        if (!active || !el.contains(active)) {
          onKeyUp?.(event);
          return;
        }
      }
    }

    event.stopPropagation();
    event.preventDefault();
    onEscape(event);

    onKeyUp?.(event);
  };

  onMounted(() => {
    window.addEventListener('keyup', handleKeyUp, true);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keyup', handleKeyUp, true);
  });

  return { handleKeyUp };
}
